export interface FetchService {
  fetch(url: string, options: RequestInit): Promise<Response>;
  fetchKeepAlive(url: string, options: RequestInit): Promise<Response>;
}

export class BrowserFetchService implements FetchService {
  async fetch(
    url: string,
    options: RequestInit
  ): Promise<Response> {
    return await window.fetch(url, options);
  }

  async fetchKeepAlive(
    url: string,
    options: RequestInit
  ): Promise<Response> {
    return await window.fetch(url, { ...options, keepalive: true });
  }
}
